import { OAuthData } from './useOAuth.interface';

import collectiveApi from 'modules/common/collectiveApi';

const fetchOAuth = async (): Promise<OAuthData> => {
    const response = await collectiveApi.get<OAuthData>('oauth/', {
        validateStatus: (status) => status === 200 || status === 404,
    });

    if (response.status === 404) {
        return { connections: {} };
    }

    return response.data;
};

export default fetchOAuth;
